import { GathererKeys } from '../../gatherers/allGatherers';
export const getMetaDescriptionFromArtifacts = artifacts => {
  const metaTags = artifacts[GathererKeys.META_TAGS];
  const metaDescriptionTags = metaTags && metaTags.find(metaTag => metaTag.name === 'description');
  const metaDescription = metaDescriptionTags && metaDescriptionTags.content;
  return metaDescription;
};